import { Decoration_Type, Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
const quickActionsModalSections = {
  CommonlyUsed: "QuickActionsPlugin_SectionTitle_CommonlyUsed",
  AI: "QuickActionsPlugin_SectionTitle_AI",
  FormatLayout: "QuickActionsPlugin_SectionTitle_FormatLayout",
  Media: "QuickActionsPlugin_SectionTitle_Media",
  Embed: "QuickActionsPlugin_SectionTitle_Embed",
  EmbedWix: "QuickActionsPlugin_SectionTitle_EmbedFromWIX"
};
export {
  Decoration_Type,
  Node_Type,
  quickActionsModalSections
};
//# sourceMappingURL=pluginTypes.js.map
